module.exports = __webpack_public_path__ + "img/tab_discover.9f412ce.png";